var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Service Partners',"subtitle":'Add Service Partner'}}),_c('service-partner-form',{attrs:{"action":"add"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }